import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "custom-full" }
const _hoisted_2 = {
  key: 0,
  class: "bg-[#2B2C32] rounded-lg mt-1 pt-1 pb-5"
}
const _hoisted_3 = { class: "flex justify-between mt-3 h-[40px]" }
const _hoisted_4 = {
  key: 1,
  class: "bg-[#2B2C32] rounded-lg px-8 mt-1 pt-1 pb-5"
}
const _hoisted_5 = {
  key: 0,
  class: /*@__PURE__*/_normalizeClass('w-full hidden-component')
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_List = _resolveComponent("List")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass('p-3 flex content-main ' + (_ctx.action.component ? ' half-it gap-5' : 'gap-5'))
  }, [
    _createElementVNode("div", _hoisted_1, [
      (_ctx.vg_selectedLocation.id)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _cache[2] || (_cache[2] = _createElementVNode("h2", { class: "text-white font-semibold text-[20px]" }, "Access Tokens", -1)),
              (!_ctx.action.component)
                ? (_openBlock(), _createElementBlock("button", {
                    key: 0,
                    class: "text-white bg-theme-green hover:bg-green-600 py-1 h-10 px-1 text-2xl border-0 rounded-md cursor-pointer",
                    onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.addUpdate({ component: 'Add', data: {}})))
                  }, [...(_cache[1] || (_cache[1] = [
                    _createElementVNode("span", null, [
                      _createElementVNode("svg", {
                        fill: "currentColor",
                        width: "32",
                        height: "32",
                        viewBox: "0 0 24 24",
                        xmlns: "http://www.w3.org/2000/svg"
                      }, [
                        _createElementVNode("path", { d: "M19,13H13V19H11V13H5V11H11V5H13V11H19V13Z" })
                      ])
                    ], -1)
                  ]))]))
                : _createCommentVNode("", true)
            ]),
            _createVNode(_component_List, {
              selectedItemCallback: _ctx.selectedItem,
              clearComponent: _ctx.clearComponent,
              iscomponentactive: _ctx.action.component ? true : false
            }, null, 8, ["selectedItemCallback", "clearComponent", "iscomponentactive"])
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_4, [...(_cache[3] || (_cache[3] = [
            _createElementVNode("p", { class: "text-center text-theme-red mt-3" }, "Please select a location.", -1)
          ]))]))
    ]),
    (_ctx.action.component)
      ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
          (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.action.component), {
            item: _ctx.action.data,
            clearComponent: _ctx.clearComponent
          }, null, 8, ["item", "clearComponent"]))
        ]))
      : _createCommentVNode("", true)
  ], 2))
}